// AI Generated Component
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-too-many-page-links',
    standalone: false,
    template: `
        <h5 translate
            [translate-n]="count(seo.content)"
            translate-plural="There are [[$count]] internal links on this page">
            There is 1 internal link on this page
        </h5>
    `,
})
export class SeoInformationTooManyPageLinksComponent {
    @Input() seo: any;

    count (content: any): any {
        if (!Array.isArray(content) && !isNaN(parseFloat(content)) && isFinite(content)) {
            return content;
        }

        return 0;
    }
}
